var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main", style: { background: _vm.background } },
    [
      _c(
        "van-row",
        [
          _c(
            "van-col",
            { attrs: { span: "24" } },
            _vm._l(_vm.headerImages, function(img, key) {
              return _c("img", {
                key: key,
                staticClass: "top-Image",
                attrs: { src: _vm.dns + img }
              })
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-row",
        { attrs: { id: "form" } },
        [
          _c(
            "van-col",
            { staticClass: "form-row", attrs: { span: "22", offset: "1" } },
            [
              _c("div", { staticClass: "input-control" }, [
                _c("label", [_vm._v("姓名")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.orderInfo.userName,
                      expression: "orderInfo.userName"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "请输入身份证上的真实姓名"
                  },
                  domProps: { value: _vm.orderInfo.userName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.orderInfo, "userName", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-control" }, [
                _c("label", [_vm._v("电话")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.orderInfo.userMobile,
                      expression: "orderInfo.userMobile"
                    }
                  ],
                  attrs: { type: "text", placeholder: "请输入收货人电话" },
                  domProps: { value: _vm.orderInfo.userMobile },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.orderInfo, "userMobile", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-control" }, [
                _c("label", [_vm._v("身份证号")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.orderInfo.idcard,
                      expression: "orderInfo.idcard"
                    }
                  ],
                  attrs: { type: "text", placeholder: "请输入您的身份证号码" },
                  domProps: { value: _vm.orderInfo.idcard },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.orderInfo, "idcard", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-control" }, [
                _c("label", [_vm._v("收货城市")]),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "text", placeholder: "点击选择收货地址" },
                  domProps: { value: _vm.orderInfo.city },
                  on: {
                    click: function($event) {
                      return _vm.handleCityClick()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-control" }, [
                _c("label", [_vm._v("详细地址")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.orderInfo.userAddress,
                      expression: "orderInfo.userAddress"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "镇+村+街道号/小区名称+楼层/门牌号"
                  },
                  domProps: { value: _vm.orderInfo.userAddress },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.orderInfo,
                        "userAddress",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-control" }, [
                _c("label", [_vm._v("备注")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.orderInfo.remark,
                      expression: "orderInfo.remark"
                    }
                  ],
                  attrs: { type: "textarea", placeholder: "" },
                  domProps: { value: _vm.orderInfo.remark },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.orderInfo, "remark", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-control" }, [
                _c("span", { staticStyle: { color: "#07c160" } }, [
                  _vm._v("免费领取设备，每人限领一张")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-control" },
                [
                  _c(
                    "van-button",
                    {
                      attrs: { type: "warning", block: "" },
                      on: { click: _vm.createOrder }
                    },
                    [_vm._v("立即领取")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-row",
        _vm._l(_vm.footerImages, function(img, key) {
          return _c("img", {
            key: key,
            staticClass: "top-Image",
            attrs: { src: _vm.dns + img }
          })
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          style: { height: "40%" },
          attrs: { position: "bottom" },
          model: {
            value: _vm.showAreaList,
            callback: function($$v) {
              _vm.showAreaList = $$v
            },
            expression: "showAreaList"
          }
        },
        [
          _c("van-area", {
            attrs: { "area-list": _vm.areaJs },
            on: {
              cancel: function($event) {
                _vm.showAreaList = false
              },
              confirm: _vm.handleCityConfirm
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22095eb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22095eb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/kuaishou/promotePage03.vue
// module id = null
// module chunks = 